import { Component, Input } from '@angular/core';
import { FormFieldAbstractComponent } from '../form-field-abstract.component';

@Component({
  selector: 'app-form-field-password',
  templateUrl: './form-field-password.component.html',
})
export class FormFieldPasswordComponent extends FormFieldAbstractComponent {
  @Input() public autocomplete = 'current-password';
  password = '';
  displayValue = '';
  showPassword = false;
  revealTimeout: any;

  get showError(): boolean {
    return this.field.touched && !this.field.valid;
  }

  ngOnInit(): void {
    this.password = (this.field.value as string) || '';
    this.updateDisplayValue();
  }

  toggleVisibility(): void {
    this.showPassword = !this.showPassword;
    this.updateDisplayValue();
  }

  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const newValue = input.value;

    const prevValue = this.displayValue;
    const inputDiff = newValue.length - prevValue.length;

    if (inputDiff > 0) {
      const addedChar = newValue.slice(-1);
      this.password += addedChar;
    } else if (inputDiff < 0) {
      this.password = this.password.slice(0, inputDiff);
    }

    this.field.setValue(this.password);

    if (!this.showPassword) {
      this.revealLastCharacter();
    } else {
      this.displayValue = this.password;
    }
  }

  onPaste(event: ClipboardEvent): void {
    // This prevents onInput from also being triggered
    event.preventDefault();

    const { clipboardData } = event;
    this.password = clipboardData?.getData('text') || '';

    this.field.setValue(this.password);

    if (!this.showPassword) {
      this.revealLastCharacter();
    } else {
      this.displayValue = this.password;
    }
  }

  revealLastCharacter(): void {
    clearTimeout(this.revealTimeout);

    const masked = '•'.repeat(
      (this.password.length || 1) - 1
    );
    const lastChar = this.password.slice(-1);
    this.displayValue = masked + lastChar;

    this.revealTimeout = setTimeout(() => {
      this.updateDisplayValue();
    }, 1000);
  }

  updateDisplayValue(): void {
    this.displayValue = this.showPassword
      ? this.password
      : '•'.repeat(this.password.length);
  }
}
